var _style, _path, _polyline, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#192852;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.4,26.6c0,0,3,0.6,5.1,2.9c0.3,0.6,2.7,3.4-5.3,6.2c-2.6,0.6-12,3.4-23.5-0.7c-1.2-0.6-9-4,1-8.4"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "5.4,24.8 8.9,26.5 7.4,30.1 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,32.7v-13L4.7,9.5c0,0-1.1-1.1,0-2.9c0.6-0.5,1.8-1.3,4,1s6.2,6.4,6.2,6.4s1.4,1.4,3.1,0.7 c0.2-1,0-2.3,0-2.3s-1.2-0.6-1.3-2.5C16.6,8,16.7,6,16.7,6s0.3-2.3,2.7-2.2S21.9,4,21.9,4s2,0.4,2,2.8s0,3.3,0,3.3s0.3,1.6-1.2,2.5 c0,0.9,0.1,2.2,0.1,2.2l1.2-0.1c0,0,1.4-0.3,2.4-1.4s6.7-6.7,6.7-6.7S35.2,5,36.2,7c0.1,0.3,1.2,1.6-0.9,3.5 c-1.9,1.9-9.1,9.1-9.1,9.1v13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,19.8c0,0,2.7,3.1,2.9,6c0,0.8-0.5,2.7-3.4,2.6c-0.7-0.3-3.6-1.2-1.8-5.3C19.3,20.7,20.4,19.8,20.4,19.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyWater);
export default __webpack_public_path__ + "static/media/BodyWater.43179b1713d386ef1efbd244cc47b35d.svg";
export { ForwardRef as ReactComponent };